export default __webpack_public_path__ + "static/media/howitworks.7f11ea09.png";